__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "home";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			initExternal(3);
			initExternal(5);
			initExternal(7);
			initExternal(9);
			initExternal(11);
			initExternal(13);
			initExternal(15);
			initExternal(17);
			initExternal(19);
			initExternal(21);
			initExternal(23);
			initExternal(25);
			initExternal(27);
			initExternal(29);
			initExternal(31);
			initExternal(33);
			initExternal(35);
			initExternal(37);
			initExternal(39);
			initExternal(41);
			initExternal(43);
			initExternal(45);
			initExternal(47);
			initExternal(49);
			initExternal(51);
			initExternal(53);
			initExternal(55);
			initExternal(57);
			initExternal(59);
			initExternal(61);
			initExternal(63);
			initExternal(66);
			initExternal(68);
			initExternal(70);
			initExternal(72);
			initExternal(74);
			initExternal(76);
			initExternal(78);
			initExternal(80);
			initExternal(84);
			initExternal(86);
			initExternal(88);
			initExternal(90);
			initExternal(92);
			initExternal(94);
			initExternal(96);
			initExternal(98);
			initExternal(100);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};